import dayjs from 'dayjs'
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat.js'
import durationPlugin from 'dayjs/plugin/duration.js'
import relativeTimePlugin from 'dayjs/plugin/relativeTime.js'

// Initialize dayjs plugins
dayjs.extend(durationPlugin)
dayjs.extend(relativeTimePlugin)
dayjs.extend(customParseFormatPlugin)

/**
 * Formats seconds into a minutes:seconds string (MM:SS)
 *
 * @param seconds - Number of seconds to format
 * @returns Formatted time string in MM:SS format with leading zeros for seconds
 */
export function formatSecondsToMinutes(seconds: number): string {
  const duration = dayjs.duration(seconds, 'seconds')
  const minutes = Math.floor(duration.asMinutes())
  const remainingSeconds = Math.floor(duration.asSeconds() % 60)

  // Format as MM:SS with leading zeros for seconds
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}

/**
 * Formats a date to a localized string
 *
 * @param date - Date to format
 * @param format - Optional format string
 * @returns Formatted date string
 */
export function formatDate(date: Date | string, format = 'DD/MM/YYYY'): string {
  return dayjs(date).format(format)
}

/**
 * Formats a date to a localized time string
 *
 * @param date - Date to format
 * @param format - Optional format string
 * @returns Formatted time string
 */
export function formatTime(date: Date | string, format = 'HH:mm'): string {
  return dayjs(date).format(format)
}

/**
 * Formats a date to a relative time string (e.g., "2 hours ago")
 *
 * @param date - Date to format
 * @returns Relative time string
 */
export function formatRelativeTime(date: Date | string): string {
  return dayjs(date).fromNow()
}

// Export the dayjs instance for direct use if needed
export { dayjs }
